import { render, staticRenderFns } from "./SettingsIndex.vue?vue&type=template&id=5ab2c4a6&scoped=true"
import script from "./SettingsIndex.vue?vue&type=script&lang=js"
export * from "./SettingsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2c4a6",
  null
  
)

export default component.exports